var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M17.884 3.882a.63.63 0 0 0-.536-.113l-4.775 1.194L7.78 2.566a.63.63 0 0 0-.432-.047l-5 1.25a.625.625 0 0 0-.473.606v11.25a.624.624 0 0 0 .777.606l4.775-1.193 4.793 2.396a.64.64 0 0 0 .432.047l5-1.25a.625.625 0 0 0 .473-.606V4.375a.63.63 0 0 0-.24-.493Zm-9.759.254 3.75 1.875v9.853l-3.75-1.875zm-5 .727 3.75-.937v9.96l-3.75.938v-9.96Zm13.75 10.274-3.75.937v-9.96l3.75-.938z"
})));
export default SvgMapIcon;